module.exports = __webpack_public_path__ + "static/img/team-build-03.153ef71.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/team-build-03.jpg
// module id = 5hw+
// module chunks = 1